import { render, staticRenderFns } from "./WashStorageArea.vue?vue&type=template&id=7183b2bd&scoped=true&"
import script from "./WashStorageArea.vue?vue&type=script&lang=js&"
export * from "./WashStorageArea.vue?vue&type=script&lang=js&"
import style0 from "./WashStorageArea.vue?vue&type=style&index=0&id=7183b2bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7183b2bd",
  null
  
)

export default component.exports